$(document).ready(function () {
  // Togggle Filter
  var toggleBtn = $('#bc-sf-filter-tree-mobile');
  var filter = $("#bc-sf-filter-left");
  var bg = $('.bg-sidebar');
  toggleBtn.click(function(){
      filter.addClass("active");
      bg.addClass("active");
      $('body').addClass('no-scroll');
  });

  // Close filter when click close-button
  $('.bs-filter-header .close-btn').click(function(){
      closeFilter();
  });
  // Close filter when click apply-button
  $('.bc-sf-filter-bottom .apply').click(function(){
      closeFilter();
  });
  // Close filter when click outside filter wrapper
  $(document).on("click", function(e){
      if(!filter.is(e.target)
      && filter.has(e.target).length === 0
      && filter.hasClass('active')
      && !toggleBtn.is(e.target)
      && toggleBtn.has(e.target).length === 0){
          closeFilter();
      }
  });

  function closeFilter(){
      filter.removeClass("active");
      bg.removeClass("active");
      $('body').removeClass('no-scroll');
  }

  // Custom mobile search
  $('.btn-search-mobile').on('click', function(){
      // $('body').addClass('open-minicart');
      $('#SearchDrawer').show();
      $('.search-form__input.search-bar__input').focus();
  });

  $('.close-search-mobile').click(function(){
      // $('body').removeClass('open-minicart');
      $('#SearchDrawer').hide();
      if ($('body').hasClass('overlay')) {
        $('body').removeClass('overlay')
     }
  });
  
  /* AOS animation */ 
  AOS.init({
    once: true,
  });

  // Filter brands 
  $('.characters').click(function(){
      $('.characters').removeClass('active');
      $(this).toggleClass('active');
      let brands = $('.brand-filter-item');
      var char = $(this).data('char');
      brands.hide();
      brands.each(function() {
          var this_char = $(this).data('char');
          if (char == this_char) {
              $(this).fadeIn(300);
          }
        });
  });
  var brand_item = $('.brand-filter-item');
  brand_item.each(function(){
      if ($.trim($(this).find("ul").html()) == "") {
          $(this).remove();
      }
  });
  var characters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  var brand_items = $('.page-brands .brand-filter-item');
  brand_items.each(function(){
      var char = $(this).data('char');
      if (char == '#') {
          $(this).find('li').each(function () {
              var data_title = $(this).data('title');
              console.log(data_title);
              if($.inArray(data_title, characters) >= 0 ){
                  $(this).hide();
                }
          });
      } else {
          $(this).find('li').each(function () {
              var data_title = $(this).data('title');
              if (data_title != char) {
                  $(this).hide();
              }
          });
      }
  });
    let player = false
    if (document.getElementById('vimeo-iframe')) {
        player = new Vimeo.Player(document.getElementById('vimeo-iframe'))
    }
    let $video_mp4 = $('#video_mp4')
    $('#play-video').click(function () {
        $(this).parents('.video__text-content').fadeOut('slow')
        $(this).parents('.video-section-wrapper').find('.video__image').fadeOut('slow')
        if (player) {
            player.play();
        } else {
            $video_mp4.get(0).play()
        }
    })

    /* Feature collection carousel section */
    $('.featured-collection-carousel').each(function (e) {
        $(this).owlCarousel({
            dots: false,
            nav: true,
            loop: true,
            margin:48,
            navText : [
                '<i class="fas fa-chevron-left"></i>',
                '<i class="fas fa-chevron-right"></i>'
            ],
            responsiveClass:true,
            responsive:{
                0:{
                    items:2,
                    nav:true
                },
                600:{
                    items:3,
                    nav:true
                },
                1000:{
                    items:5,
                    nav:true,
                    loop:false
                }
            }
        })
    });

    $('.shopby_collection-carousel').each(function (e) {
        let item = $(this).data('item');
        $(this).owlCarousel({
            dots: false,
            nav: true,
            loop: true,
            margin: 24,
            navText : [
                '<i class="fas fa-chevron-left"></i>',
                '<i class="fas fa-chevron-right"></i>'
            ],
            responsiveClass:true,
            responsive:{
                0:{
                    items: 2,
                    nav:true,
                    margin: 12,
                },
                600:{
                    items: 3,
                    nav:true
                },
                1000:{
                    items: item,
                    nav:true,
                    loop:false
                }
            }
        })
    });

    $('.featured-product-carousel').each(function (e) {
        $(this).owlCarousel({
            dots: false,
            nav: true,
            loop: true,
            margin: 0,
            navText : [
                '<i class="fas fa-chevron-left"></i>',
                '<i class="fas fa-chevron-right"></i>'
            ],
            responsiveClass:true,
            responsive:{
                0:{
                    items: 1,
                    nav:true
                },
                600:{
                    items: 1,
                    nav:true
                },
                1000:{
                    items: 1,
                    nav:true,
                    loop:false
                }
            }
        })
    });

    $('.cta-read-more').on('click', function(e){
        e.preventDefault();
        $(this).parents('.short-des').slideUp().next('.full-des').slideDown();
    });
});

